/**
 * App root.
 *
 *   BrandProvider          — CSS custom properties + tenant brand
 *   AuthInitializer        — subscribes to Supabase auth state once
 *   RouterProvider         — public routes + RequireAuth-gated app shell
 */

import { type ReactNode }   from 'react'
import { RouterProvider }    from 'react-router'
import { BrandProvider }     from '@/lib/brand/BrandProvider'
import { useAuthInit }       from '@/hooks/useAuth'
import { router }            from '@/router'

function AuthInitializer(): null {
  useAuthInit()
  return null
}

export default function App(): ReactNode {
  return (
    <BrandProvider>
      <AuthInitializer />
      <RouterProvider router={router} />
    </BrandProvider>
  )
}
